export default __webpack_public_path__ + "static/media/waves.11ba7f4b.svg";